<div class="company-select-modal">
    <div class="clearfix text-right" *ngIf="!formMode">
        <app-custom-button class="md-button cancel-dialog" aria-label="Dialog schliessen" (click)="cancel()"
                           icon="icon ic-btn_close"></app-custom-button>
    </div>
    <ng-container *ngIf="!formMode">
        <ng-container *ngIf="businessContacts.length > 0">
            <h3>Bitte ein Unternehmen auswählen:</h3>
            <div class="scroll">
                <table>
                    <thead class="entry-header">
                    <tr>
                        <th class="name">Name</th>
                        <th class="street">Straße</th>
                        <th class="city">PLZ / Ort</th>
                        <th class="certification" *ngIf="showCertification">Zertifizierung</th>
                        <th class="email" *ngIf="emailRequired">Email</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="entry"
                        *ngFor="let company of businessContacts, let i = index, let odd=odd; let even=even;">
                        <td class="name" [ngClass]="{ odd: odd, even: even }"
                            (click)="selectBusinessContact(company)">{{company.companyName}}</td>
                        <td class="street" [ngClass]="{ odd: odd, even: even }"
                            (click)="selectBusinessContact(company)">{{company.street !== undefined ? company.street : ""}}</td>
                        <td class="city" [ngClass]="{ odd: odd, even: even }"
                            (click)="selectBusinessContact(company)">{{company.zipCode !== undefined ? company.zipCode : ""}} {{company.city !== undefined ? company.city : ""}}</td>
                        <td class="certification" [ngClass]="{ odd: odd, even: even }" *ngIf="showCertification"
                            (click)="selectBusinessContact(company)">{{company.certification.includes('') || company.certification.length == 0 ? "keine" : company.certification.join(', ')}}</td>
                        <td class="email" *ngIf="emailRequired" [ngClass]="{ odd: odd, even: even}"
                            (click)="selectBusinessContact(company)">{{company.email !== undefined ? company.email : ""}}</td>
                        <td [ngClass]="{ odd: odd, even: even }">
                            <mat-icon (click)="editBusinessContact(i)">edit</mat-icon>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>
        <ng-container *ngIf="businessContacts.length === 0">
            <p>Es gibt keine Einträge im angegebenen PLZ-Gebiet</p>
        </ng-container>
        <div class="button-row">
            <app-custom-button color="primary" aria-label="Neue Adresse anlegen" (click)="addBusinessContact()"
                               text="Neue Adresse anlegen"></app-custom-button>
        </div>
    </ng-container>
    <ng-container *ngIf="formMode">
        <h3>Adresse anlegen/bearbeiten:</h3>
        <div class="white-box">
            <div class="section-edit-company">
                <div class="row">
                    <div class="col-md-4">
                        <app-custom-input inputId="zipCode" styleClass="mat-primary"
                                          [(result)]="currentContact.zipCode" maxlength="5"
                                          label="PLZ" [errors]="errors"
                                          modelPath="zipCode" restrict="[0-9]" required="true"
                                          [validationConstraints]="validationConstraints"
                                          (resultChange)="validateForm()"
                                          [disabled]="true"></app-custom-input>
                    </div>
                    <div class="col-md-8">
                        <app-custom-input inputId="city" styleClass="mat-primary"
                                          [(result)]="currentContact.city"
                                          label="Ort" [errors]="errors" required="true"
                                          modelPath="city"
                                          [validationConstraints]="validationConstraints"
                                          (resultChange)="validateForm()"></app-custom-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <app-custom-input inputId="street" styleClass="mat-primary"
                                          [(result)]="currentContact.street"
                                          label="Anschrift" required="true" [errors]="errors"
                                          modelPath="street"
                                          [validationConstraints]="validationConstraints"
                                          (resultChange)="validateForm()" (blur)="validateStreet()"></app-custom-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <app-custom-input inputId="companyName" styleClass="mat-primary"
                                          [(result)]="currentContact.companyName"
                                          label="Name" required="true" [errors]="errors"
                                          modelPath="companyName"
                                          [validationConstraints]="validationConstraints"
                                          (resultChange)="validateForm()"></app-custom-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12" *ngIf="emailRequired">
                        <app-custom-input inputId="email" styleClass="mat-primary" [(result)]="currentContact.email"
                                          label="Email"
                                          modelPath="email"
                                          [errors]="errors"
                                          [validationConstraints]="validationConstraints"
                                          (resultChange)="validateForm()"></app-custom-input>
                    </div>
                </div>
                <div class="row certificate-select" *ngIf="showCertification">
                    <div class="col-md-12">
                        <label>Zertifizierung</label>
                        <mat-form-field>
                            <mat-select [(ngModel)]="currentContact.certification" multiple
                                        (selectionChange)="validateForm()"
                                        [title]="currentContact.certification"
                                        [disabled]="currentContact.id && !isLogicheckUser">
                                <mat-option (click)="deselectCertificates(true)" [value]="''">keine</mat-option>
                                <mat-option *ngFor="let option of certificationOptions "
                                            (click)="deselectCertificates(false)"
                                            [value]="option.value">
                                    {{option.display}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <a href="/assets/pdf/Auflistung_Zertifizierungen.pdf" target="_blank"><i
                            class="icon-ic_pdf"></i>
                            Logo/Stempel </a>
                    </div>
                    <p *ngIf="currentContact.id && !isLogicheckUser" style="color: #495252">Wenden Sie sich bei Änderungen zur Zertifizierung bitte an <a href="mailto:horch@logicheck.de">horch@logicheck.de</a></p>
                </div>
                <div id="warning" *ngIf="warning">
                    <br>
                    {{ warning }}
                </div>
            </div>
        </div>
        <div class="button-row">
            <app-custom-button color="primary" aria-label="Zurück zur Auswahl" (click)="cancelEdit()"
                               text="Zurück zur Auswahl"></app-custom-button>
            <app-custom-button color="primary" aria-label="Speichern" (click)="save()" text="Speichern"
                               [disabled]="!formValid"></app-custom-button>
        </div>
    </ng-container>
</div>

